import { File, Paths } from 'expo-file-system'
import * as Sharing from 'expo-sharing'
import { Platform } from 'react-native'

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export async function downloadXLSX(data: Uint8Array, filename: string): Promise<void> {
    if (Platform.OS === 'web') {
        const blob = new Blob([new Uint8Array(data)], { type: XLSX_MIME })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    } else {
        const file = new File(Paths.cache, filename)
        if (file.exists) {
            file.delete()
        }
        file.create()
        file.write(data)
        await Sharing.shareAsync(file.uri, {
            mimeType: XLSX_MIME,
            dialogTitle: 'Export Time Entries',
        })
    }
}

export async function downloadCSV(content: string, filename: string): Promise<void> {
    if (Platform.OS === 'web') {
        downloadCSVWeb(content, filename)
    } else {
        await downloadCSVNative(content, filename)
    }
}

function downloadCSVWeb(content: string, filename: string): void {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}

async function downloadCSVNative(content: string, filename: string): Promise<void> {
    const file = new File(Paths.cache, filename)
    if (file.exists) {
        file.delete()
    }
    file.create()
    file.write(content)
    await Sharing.shareAsync(file.uri, {
        mimeType: 'text/csv',
        dialogTitle: 'Export Time Entries',
        UTI: 'public.comma-separated-values-text',
    })
}
